import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaCreditoOrcamentarioReceitasPropriasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            recurso: filtro.recurso ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao ? filtro.destinacao.map(e => e.value).join() : null,
            grau: filtro.grau ? filtro.grau.value : null,
        }

        return this.conex.post(urlConsultaDiarias + 'consultaCreditoOrcamentarioReceitasProprias/', JSON.stringify(data))
    }
}

export default ConsultaCreditoOrcamentarioReceitasPropriasService
